import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-password-reset',
  standalone: false,
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.scss',
})
export class PasswordResetComponent implements OnInit, OnDestroy {
  model: Record<string, any> = {};
  loginQueryParams: Record<string, string> = {};

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        const email = (params.get('email') || '').trim();

        const resetCode = (
          params.get('otc') ||
          params.get('oneTimeCode') ||
          ''
        ).trim();

        this.model = {
          ...(email ? { email } : {}),

          // Keep both to support whichever field name the Axis predefined form uses.
          ...(resetCode ? { otc: resetCode } : {}),
          ...(resetCode ? { oneTimeCode: resetCode } : {}),
        };

        this.loginQueryParams = {
          ...(email ? { email } : {}),
        };
      });
  }

  onFormSubmit(res: any): void {
    if (!res || res.status !== 'success') return;

    this.router.navigate(['/login'], {
      queryParams: this.loginQueryParams,
      state: {
        toast: res.message || 'Password reset successfully. Please log in.',
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
